import React, { useState } from 'react';
import { Text, Segmented } from '../../../components';
import SummaryDetails from './SummaryDetails';
import { RMCard } from '../RMCard';
import { useCardLoadingState } from '../CardLoadingUtils';
import classNames from 'classnames';

export const SummaryDetailsCard = ({ title, details, modernizationSavingsFetch, headerRight, segmentedOptions, className = '', queryState, ...props }) => {
    const { loading, isError, disabled } = useCardLoadingState(queryState);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const resolvedDetails = modernizationSavingsFetch ? modernizationSavingsFetch(selectedIndex) : details;

    return (
        <RMCard className={classNames(className, 'summary-details-card')} showMoreIcon={false} isError={isError} {...props}>
            <header>
                {title && (
                    <Text size="large" color="secondary">
                        {title}
                    </Text>
                )}
                {segmentedOptions ? (
                    <div className="header-right">
                        <Segmented
                            options={segmentedOptions}
                            value={segmentedOptions[selectedIndex]}
                            onChange={(val) => setSelectedIndex(segmentedOptions.indexOf(val))}
                            size="small"
                            shape="round"
                            disabled={disabled}
                        />
                    </div>
                ) : headerRight && (
                    <div className="header-right">
                        <Text size="small" color="secondary">
                            {headerRight}
                        </Text>
                    </div>
                )}
            </header>
            <SummaryDetails details={resolvedDetails} isLoading={loading} />
        </RMCard>
    );
};
